import React from 'react';

import { PageContent } from '../../article/styles';

import { PrismicSliceHeroTitle } from '../../../../../types';

import * as S from './styles';

type Props = {} & PrismicSliceHeroTitle;

const Hero = ({ textColor, image, title, secondaryTitle }: Props) => {
  return (
    <S.Hero textColor={textColor} image={image}>
      <PageContent alignLeft>
        <S.TextContent>
          <S.Title data={title} />
          <S.SubTitle data={secondaryTitle} />
        </S.TextContent>
      </PageContent>
    </S.Hero>
  );
};

export default Hero;
